<template>
    <div class="container-launch-home">
        <div class="container-launch-home-icon">
            <em class="far fa-building" />
        </div>

        <div class="container-launch-home-text">
            <div class="title">Gestão para Lançamentos Imobiliários</div>
            <div class="subtitle">Uma Solução completa para você operacionar os seus lançamentos imobiliários agilizando todas as etapas dos processos de atendimento ao cliente e vendas.</div>
        </div>

        <div class="container-launch-home-button">
            <div class="button">
                <ui-button
                    design="md primary-alt"
                    type="submit"
                    @click="createLaunch"
                >
                    <i class="fal fa-plus" />
                </ui-button>
            </div>

            <span class="button-text">Clique para criar lançamento</span>
        </div>
    </div>
</template>

<script>
	import { uiButton } from '@/components/ui/buttons'

	export default {
		name: 'launch-default',

		components: {
			uiButton,
		},

		methods: {
			createLaunch() {
				this.$router.push({
					name: 'launch.management.create.mainData'
				})
			},
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl';
</style>